import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogAcceptFastQuoteBidComponent } from '@app-components/dialog/dialog-accept-fast-quote-bid/dialog-accept-fast-quote-bid.component';
import { DialogRejectFastQuoteBidComponent } from '@app-components/dialog/dialog-reject-fast-quote-bid/dialog-reject-fast-quote-bid.component';
import { DialogConfirmPricingComponent } from '@app-components/evaluation/evaluation-vehicle-detail/dialog/dialog-confirm-pricing/dialog-confirm-pricing.component';
import { EvaluationVehicle, FastQuoteBids } from '@app-model/evaluation';
import { BidSuggestionStatus } from '@app-model/fast-quote';
import { BidStatus, CounterOffer } from '@app-services/dealer.service';
import { FastQuoteService } from '@app-services/fast-quote.service';
import { OemDealerService } from '@app-services/oem-dealer.service';
import { ProposalMarginLimitHelper } from '@app-model/proposal-margin.model';
import { DefaultStatus } from '@app-model/login';
import {
  belowMinimumMarginMessage,
  isBelowUserMarginLimit,
} from '@app-utils/proposal-margin.utils';
import { SharedAnimations } from '@app-shared/animations/shared-animations';
import { Permission, Role, UserInfo } from '@app/store/session/session.store';
import { ToastrService } from 'ngx-toastr';
import { reloadCurrentRoute } from '@app-utils/router-utils';

@Component({
  selector: 'app-fast-quote-offer',
  templateUrl: './fast-quote-offer.component.html',
  styleUrls: ['./fast-quote-offer.component.scss'],
  animations: [SharedAnimations]
})
export class FastQuoteOfferComponent implements OnInit {
  showDetail: boolean;
  animationState = 'out';
  loading: boolean;
  loadingReject: boolean;
  counterOfferErrorMessage: string;
  counterOffer: CounterOffer;
  private marginLimit: ProposalMarginLimitHelper | null = null;

  @Input() vehicle: FastQuoteBids;
  @Input() index: any;
  @Input() fastQuoteId: string;
  @Input() theme: string;
  @Input() vStatus: string;
  @Input() eval: EvaluationVehicle;
  @Input() userInfo: UserInfo;

  constructor(
    public service: FastQuoteService,
    public toastr: ToastrService,
    public router: Router,
    private dialog: MatDialog,
    private oemDealerService: OemDealerService,
  ) { }

  ngOnInit() {
    const oemDealerId = this.eval?.oemDealerId;
    if (oemDealerId) {
      this.oemDealerService.getProposalMarginLimit(oemDealerId).subscribe({
        next: (limit) => {
          this.marginLimit = limit;
        },
      });
    }
    if (this.index == '0') {
      this.showDetail = true;
      this.animationState = 'in';
    } else {
      this.showDetail = false;
      this.animationState = 'out';
    }
  }

  public toggleDetail() {
      this.showDetail = !this.showDetail;
      this.animationState = this.animationState === 'out' ? 'in' : 'out';
  }

  public confirmBid() {
    if (this.isMarginBlocked) {
      this.toastr.error(belowMinimumMarginMessage(this.marginLimit?.effectiveLimit));
      return;
    }
    this.dialog.open(DialogAcceptFastQuoteBidComponent, {
      width: "500px",
      hasBackdrop: true,
      data: {
        vehicle: this.vehicle,
        value: this.value,
        costPrice: this.eval?.price ?? null,
        marginLimit: this.marginLimit,
      }
    })
      .afterClosed()
      .subscribe(( success: boolean ) => {
        if (success) {
          this.acceptBid();
        }
    });
  }
  
  public acceptBid() {
    if (!this.eval.price && this.eval.fillPriceBeforePurchase) {
      this.dialog.open(DialogConfirmPricingComponent, {
        width: "350px",
        hasBackdrop: true,
        data: {
          vehicle: this.eval,

        }
      })
        .afterClosed()
        .subscribe((result: { success?: boolean; info?: EvaluationVehicle } | undefined) => {
          if (!result?.success || !result.info) {
            return;
          }

          this.eval.price = result.info.price;
          this.eval.priceCent = result.info.priceCent;
          this.eval.listPrice = result.info.listPrice;
          this.eval.minSellPrice = result.info.minSellPrice;
          this.acceptBid();
        });
      return;
    }

    this.loading = true;
    this.service.acceptBidFastQuote(this.vehicle, this.fastQuoteId).subscribe((response: DefaultStatus) => {
      if (response.status == 'OK') {
        this.toastr.info('Parabéns! Você aceitou uma oferta de cotação rápida.');
        setTimeout(() => {
          reloadCurrentRoute(this.router);
        }, 2000);
      } else if (response.status === 'DONT_OWN_VEHICLE') {
        this.toastr.error('Você não tem permissão para concluir esta venda.');
      } else if (response.status === 'BELOW_MINIMUM_MARGIN') {
        this.toastr.error(belowMinimumMarginMessage(response.effectiveMarginLimit));
      } else {
        this.toastr.error(BidSuggestionStatus[response.status] || 'Não foi possível aceitar esta proposta.');
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      });
  }

  reasonToRejectBid(){
    this.dialog.open(DialogRejectFastQuoteBidComponent, {
      width: "500px",
      hasBackdrop: true,
      data: {
        vehicle: this.vehicle
      }
    })
      .afterClosed()
      .subscribe(( reason: string ) => {
        if (reason) {
          this.vehicle.rejectionReason = reason as "CUSTOMER_GAVE_UP" | "PRICE_TOO_LOW" | "OTHER_DEALER";
          this.rejectBid();
        }
      });
  }

  public rejectBid() {
    this.loadingReject = true;
    this.service.rejectBidFastQuote(this.vehicle, this.fastQuoteId).subscribe((response: any) => {
      if (response.status == 'OK') {
        this.toastr.info('Oferta rejeitada. O comprador será avisado e terá a chance de fazer outra oferta.');
      } else if (response.status == 'INACTIVE') {
        this.toastr.error('Esta cotação rápida está inativa.');
      } else {
        this.toastr.error('Ocorreu um erro e não foi possível rejeitar essa oferta: ' + response.status);
      }
      setTimeout(() => {
        reloadCurrentRoute(this.router);
      }, 2000);
    }, error => {
      this.loadingReject = false;
    });
  }

  isSold() {

  }


  loadCounterOffer(): void {
    this.counterOffer = new CounterOffer();
    this.counterOfferErrorMessage = undefined;
  }
  closeCounterOffer(): void {
    this.counterOffer = undefined;
    this.counterOfferErrorMessage = undefined;
  }

  showCounterOfferBox(): boolean {
    return this.counterOffer !== undefined;
  }

  sendCounterOffer(): void {
    this.loading = true;
    this.counterOfferErrorMessage = undefined;
    this.vehicle.counterOffer = this.counterOffer;
    this.service.makeCounterOffer(this.fastQuoteId, this.vehicle)
      .subscribe(result => {
        if (result.success) {
          this.counterOffer = undefined;
        } else {
          this.counterOfferErrorMessage = BidStatus[result.status];
          this.vehicle.counterOffer = undefined;
        }
        this.loading = false;
      });
  }

  getCounterOfferStatusLabel(status: string): string {
    return CounterOffer.getStatusLabel(status);
  }

  get value(): number {
    if (this.vehicle.counterOffer && this.vehicle.counterOffer.status === 'ACCEPTED') {
      return this.vehicle.counterOffer.value;
    }
    return this.vehicle.value;
  }

  get hasAcceptAnyPermission(): boolean {
    return this.userInfo?.hasAnyPermissionOrLegacy(Permission.ACCEPT_ANY_FAST_QUOTE_PROPOSAL) ?? false;
  }

  get hasAcceptHighestPermission(): boolean {
    return this.userInfo?.hasAnyPermissionOrLegacy(Permission.ACCEPT_HIGHEST_FAST_QUOTE_PROPOSAL) ?? false;
  }

  get canShowAcceptButton(): boolean {
    return this.hasAcceptAnyPermission || this.hasAcceptHighestPermission;
  }

  get canConcludeFastQuoteSale(): boolean {
    return this.userInfo?.hasPermissionOrLegacy(Permission.SEND_TO_FAST_QUOTE)
      || this.userInfo?.hasLegacyBuyRoles()
      || this.userInfo?.isAdmin()
      || false;
  }

  get isHighestBid(): boolean {
    const bids = this.eval?.fastQuote?.bidSuggestions ?? [];
    const activeValues = bids.filter(b => b.status !== 'REJECTED').map(b => b.value);
    if (!activeValues.length) {
      return true;
    }
    return this.vehicle.value >= Math.max(...activeValues);
  }

  get isMarginBlocked(): boolean {
    const min = this.marginLimit?.minimumProposalAcceptanceMargin ?? null;
    const limit = this.marginLimit?.effectiveLimit ?? null;
    const canAcceptBelow = this.userInfo?.canAcceptProposalBelowMargin() ?? false;
    return isBelowUserMarginLimit(this.value, this.eval?.price, min, limit, canAcceptBelow);
  }

  get canAcceptBid(): boolean {
    if (!this.canShowAcceptButton || !this.canConcludeFastQuoteSale) {
      return false;
    }
    if (this.isMarginBlocked) {
      return false;
    }

    if (!this.hasAcceptAnyPermission && !this.isHighestBid) {
      return false;
    }

    if (!this.eval.defaultCompetitiveFastQuote) {
      return true;
    }

    if (this.userInfo?.isAdmin() || this.userInfo?.hasRole(Role.OEM_DEALER_MANAGER)) {
      return true;
    }

    return this.isHighestBid;
  }

  get acceptDisabledTooltip(): string {
    if (this.canAcceptBid) {
      return '';
    }
    if (this.isMarginBlocked) {
      return belowMinimumMarginMessage(this.marginLimit?.effectiveLimit);
    }

    if (!this.canConcludeFastQuoteSale) {
      return 'Você não tem permissão para concluir esta venda.';
    }

    if (this.eval?.defaultCompetitiveFastQuote
      && !this.userInfo?.isAdmin()
      && !this.userInfo?.hasRole(Role.OEM_DEALER_MANAGER)) {
      return 'Apenas a maior oferta pode ser aceita em cotações competitivas.';
    }

    return 'Somente a maior proposta pode ser aceita.';
  }

  get minCounterOfferValue(): number {
    if (this.eval.defaultCompetitiveFastQuote) {
      const maxBid = Math.max(...this.eval.fastQuote.bidSuggestions.filter(b => b.status !== 'REJECTED').map(b => b.value));
      return maxBid + 1;
    }
    return this.vehicle.value + 1;
  }

}
